
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Four04Component } from 'src/app/four04/four04.component';
import { FACEBOOK_PIXEL_PROVIDER } from '../shared/services/facebook-pixel.provider'
import { BlogComponent } from './blog.component';
import { SingleBlogComponent } from './single-blog/single-blog.component';
const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: BlogComponent,
        data: { title: 'IHM Used Parts | Blog', pageTitle: 'Blog' }
      },
      {
        path: 'post/id/:id',
        pathMatch: 'full',
        component: SingleBlogComponent,
        data: { title: 'IHM Used Parts | Blog Post', pageTitle: 'Blog Post' }
      },
      {
        path: 'post/:slug',
        pathMatch: 'full',
        component: SingleBlogComponent,
        data: { title: 'IHM Used Parts | Blog Post', pageTitle: 'Blog Post' }
      }
    ]
  }
]
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    FACEBOOK_PIXEL_PROVIDER
  ]
})
export class BlogRoutingModule { }

